export const ERROR_ON_MISSING_CONFIG = 'Something is wrong with the config parameter';

export const PROJECT_NAME = 'bedrock-rdk';

export const PERSISTENT = {
  DEVICE_ID_KEY: 'deviceId',
  SYNCHRONIZE_KEY: 'synchronize',
  PROFILE_UID_KEY: 'profileUid',
  PROFILE_SECTION_KEY: 'profileSection',
  PREVIOUS_PROFILE_KEY: 'previousProfile',
  CONSENT_VERSION: 'concentVersion',
};
